import React from 'react';
import {useState, useEffect} from 'react';
import BottomCard from './Certificate';
import {directDeepLink, SOURCE_HOME} from './Certificate/util';
import './index.css';
import baseURLGlobal from '../../utils/util';
import html2canvas from "html2canvas";
import { tutorEndConfig, tutorHomeImages, resolveTutorEndAsset, globalColors, globalBackgrounds, globalText } from './tutorEndConfig';

export default function EndCampaignPage() {
    const [showDrawer, setShowDrawer] = useState(false);
    const [data, setData] = useState({});
    const [image, setImage] = useState({});
    const baseUrl = baseURLGlobal;
    let url = new URL(window.location.href);
    let token = url.searchParams.get("token");
    const text = tutorEndConfig.text || {};
    const images = tutorEndConfig.images || {};
    const endPageStyle = {
        '--tutor-page-background-color': globalColors.accent_color || '#E35C22',
        '--tutor-page-background': `url("${resolveTutorEndAsset(tutorHomeImages.page_background || 'https://cdn-wl-assets.classplus.co/production/379965/f659f314-c481-4f77-a065-598c1a2699a6.png')}")`,
        '--tutor-end-inverse-text': globalColors.white_text || '#fff',
        '--tutor-end-action-card-border-gradient': globalBackgrounds.card_border_gradient || 'linear-gradient(180.22deg, #FFFFFF -6.79%, #E1B677 99.81%)',
    };
    const certificateBoxStyle = {
        '--tutor-end-certificate-background': `url("${resolveTutorEndAsset(images.certificate_background || 'https://cdn-wl-assets.classplus.co/production/379965/46da351a-8bbe-4c84-925e-c883e8fdcd17.png')}")`,
        '--tutor-end-certificate-text': globalColors.white_text || '#fff',
    };


    useEffect(() => {
        getEndCampaignDetails();
    }, []);

    const getEndCampaignDetails = async () => {
        var myHeaders = new Headers();
        myHeaders.append("api-version", "25");
        myHeaders.append("x-access-token", token);
        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };
        await fetch(`${baseUrl}/v2/course/campaign/home`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setData(result?.data);
            })
            .catch((error) => console.log("error", error));
    };

    const captureImage = () => {
        const slideElement = document.getElementById("certificateBoxElement");
        if (!slideElement) {
            console.error("captureImage: Element not found. Ensure the selector is correct.");
            return;
        }
        html2canvas(slideElement, { scrollY: -window.scrollY, allowTaint: true, useCORS: true })
            .then((canvas) => {
                canvas.toBlob((blob) => {
                    const downloadLink = document.createElement("a");
                    document.body.appendChild(downloadLink);
                    downloadLink.download = "poster.png";
                    downloadLink.href = canvas.toDataURL("image/png");
                    setImage(downloadLink.href);
                    document.body.removeChild(downloadLink);
                });
            })
            .catch((error) => {
                console.error("captureImage: Error during canvas generation or Blob creation.", error);
            });
    };

    const handleClick = () => {
        setShowDrawer(true);
        setTimeout(() => {
            captureImage();
        }, 0);
    }
    useEffect(() => {
    }, [showDrawer, setShowDrawer]);


    return (
        <>
            <div className="homeDisplay" style={endPageStyle}>
                <div className="slideCard slideCardEndSlide">
                    <div className="cardHeader">
                        <img
                            src={images.header_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-slide-home-header-title.png'}
                            alt="title"/>
                    </div>
                    <div className="cardBody">
                        <img className="card-top-img"
                             src={images.card_top_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-end-card-top-img.png'}
                             alt="img"/>
                        <hr/>
                        <div className="card-revenue-flex">
                            <h4>{globalText.revenue_label || 'Your Revenue'}</h4>
                            <h2>{data?.totalRevenue}</h2>
                        </div>
                        <div className="end-camp-card-group">
                            <div className="end-camp-card"
                                 onClick={() => {
                                     directDeepLink(data?.formDeeplink, SOURCE_HOME)
                                 }}>
                                <img
                                    src={images.claim_rewards_icon || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-trophy-img-min.png'}
                                    alt="trophy" width={50}/>
                                <p>{text.claim_rewards_description || 'Fill the google form to claim your rewards before they expire.'}</p>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png"
                                    alt="overview card forward" height={16}/>
                            </div>
                            <div className="end-camp-card"
                                 onClick={handleClick}>
                                <img
                                    src={images.claim_certificate_icon || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-gift--img-min.png'}
                                    alt="prize" width={50}/>
                                <p>{text.claim_certificate_description || 'Claim your surprise birthday gift certificate now.'}</p>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png"
                                    alt="overview card forward" height={16}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BottomCard show={showDrawer} image={image} data={data} imageBlob={'certificateBoxElement'} setDrawer={setShowDrawer}/>

            <div id="certificateBoxElement" className="certificate-box" style={certificateBoxStyle}>
                <div className="content-data">
                    <h4>{data?.certificateData?.heading}</h4>
                    <hr/>
                    <p>{data?.certificateData?.subtext}</p>
                </div>
            </div>
        </>
    )
}
